import React from "react"
import userEvent from "@testing-library/user-event"
import { useFormContext, useForm, FormProvider } from "react-hook-form"

import { render, cleanup, waitFor } from "@testing-library/react"
import PillGroupWithComment from "../PillGroupWithComment"

afterEach(cleanup)

const pillData = [
  {
    text: "N/A",
    labelId: "N/A",
    type: "low"
  },
  {
    text: "Possibly",
    labelId: "possibly",
    type: "medium"
  },
  {
    text: "Applicable",
    labelId: "applicable",
    type: "high"
  }
]

const pillDataRevenue = [
  {
    text: "N/A",
    labelId: "N/A",
    type: "low"
  },
  {
    text: "Possibly",
    labelId: "possibly",
    type: "medium"
  },
  {
    text: "Applicable",
    labelId: "applicable",
    type: "high"
  }
]

export const PillGroupWithContext = (props) => {
  const methods = useForm()

  return (
    <FormProvider {...methods}>
      <form>
        <ConnectForm>
          {({ register }) => <PillGroupWithComment {...props} />}
        </ConnectForm>
      </form>
    </FormProvider>
  )
}

export const ConnectForm = ({ children }) => {
  const methods = useFormContext()

  return children({ ...methods })
}

describe("<PillGroup />", () => {
  it("shows legend text", () => {
    const tree = (
      <PillGroupWithContext
        legendText="Pills to choose from"
        pillGroupName="protect"
        pillData={pillData}
      />
    )
    const { queryByText } = render(tree)
    expect(queryByText("Pills to choose from")).toBeInTheDocument()
  })

  it("multiple groups display as expected", () => {
    const tree = (
      <PillGroupWithContext
        legendText="Pills to choose from two"
        pillData={pillData}
        pillGroupName="protect"
      />
    )
    const first = render(tree)

    const tree2 = (
      <PillGroupWithContext
        legendText="Pills to choose from"
        pillData={pillDataRevenue}
        pillGroupName="revenue"
      />
    )
    const second = render(tree2)

    expect(first.queryByText("Pills to choose from")).toBeInTheDocument()
    expect(second.queryByText("Pills to choose from two")).toBeInTheDocument()
    expect(second.getAllByLabelText("Possibly")).toHaveLength(2)
  })

  it("pills toggle selected in group when clicked", async () => {
    // Note: below is more of an integration test with `Pills` component to ensure that
    // callback for selected state fires as expected

    const first = render(
      <PillGroupWithContext
        legendText="Pills to choose from"
        pillGroupName="protect"
        pillData={pillData}
        onPillGroupChange={() => {}}
      />
    )

    const firstPillInGroup = first.getByLabelText("N/A")
    const secondPillInGroup = first.getByLabelText("Possibly")

    userEvent.click(firstPillInGroup)
    await waitFor(() =>
      expect(firstPillInGroup.parentElement).toHaveClass("selected")
    )

    userEvent.click(secondPillInGroup)
    await waitFor(() =>
      expect(secondPillInGroup.parentElement).toHaveClass("selected")
    )

    // ensure that first pill is no longer selected after second has been clicked
    await waitFor(() =>
      expect(firstPillInGroup.parentElement).not.toHaveClass("selected")
    )
  })

  it("comment textarea shows correctly for types", async () => {
    const first = render(
      <PillGroupWithContext
        legendText="Pills to choose from"
        pillGroupName="protect"
        pillData={pillData}
        onPillGroupChange={() => {}}
      />
    )

    const firstPillInGroup = first.queryByLabelText("N/A")
    const secondPillInGroup = first.queryByLabelText("Possibly")

    userEvent.click(firstPillInGroup)
    await waitFor(
      () =>
        expect(first.queryByText("Please provide an explanation: ")).not
          .toBeInTheDocument
    )

    userEvent.click(secondPillInGroup)
    await waitFor(
      () =>
        expect(first.queryByText("Please provide an explanation: "))
          .toBeInTheDocument
    )
  })
})
